import _ from 'lodash';
import * as types from '../types';

const creditCardModule = {
    state: {
        card: {
            number: '',
            cvc: '',
            exp_month: '',
            exp_year: '',
        },
        valid: false,
    },

    mutations: {
        [types.CREDIT_CARD__MUTATE_CC_VALIDATION](localState, validationStatus) {
            // eslint-disable-next-line no-param-reassign
            localState.valid = validationStatus;
        },
        [types.CREDIT_CARD__MUTATE_CC](localState, payload) {
            _.assign(localState.card, payload);
        },
    },

    actions: {
        [types.CREDIT_CARD__UPDATE_CC_VALIDATION]({ commit }, payload) {
            commit(types.CREDIT_CARD__MUTATE_CC_VALIDATION, payload);
        },
        [types.CREDIT_CARD__UPDATE_CC_NUMBER]({ commit }, payload) {
            const nonNumberRegex = /[^0-9]+/g;
            const numbersOnly = _.replace(`${payload.number}`, nonNumberRegex, '');
            commit(types.CREDIT_CARD__MUTATE_CC, { number: numbersOnly });
        },
        [types.CREDIT_CARD__UPDATE_CC_EXPIRATION]({ commit }, payload) {
            commit(types.CREDIT_CARD__MUTATE_CC, {
                exp_month: payload.exp_month,
                exp_year: payload.exp_year,
            });
        },
        [types.CREDIT_CARD__UPDATE_CC_CVC]({ commit }, payload) {
            commit(types.CREDIT_CARD__MUTATE_CC, payload);
        },
    },
};

export default creditCardModule;
